import { InitializerExecutor } from '@wajeez-web/core/types';
import { getPlans, PlansActions, setPlans } from '@wajeez-web/stores/product';
import { Payment } from '@wajeez/wajeez.microservices';

export const initializePlans: InitializerExecutor = async (dispatch) => {
  const plans = getPlans();

  if (!plans) {
    const res = await dispatch(PlansActions.getMyPlansAsync());

    res.payload && setPlans(res.payload as Payment.PlanOutput[]);
  } else {
    dispatch(PlansActions.setMyPlans(plans));
  }
};
